import { Box } from "@primer/react";
import { IDataGridColumn } from "./type/IDataGridProps";
import { PlaceHolder } from "../../place-holder";

interface ILoadingProps {
  dataColumn: IDataGridColumn[];
}
const rows = [1, 2, 3];
const Loading = ({ dataColumn }: ILoadingProps) => {
  return (
    <tbody>
      {rows.map((idx) => {
        return (
          <tr key={idx}>
            {dataColumn.map((col, idx) => {
              return (
                <td key={idx}>
                  <Box>
                    <PlaceHolder line_number={1} />
                  </Box>
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
};
export default Loading;
